import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { ClassModel } from '../models/class.model';
import { LessonModel } from '../models/lesson.model';
import { ResultModel } from '../models/result.model';
import { StudentModel } from '../models/student.model';
import { SubjectModel } from '../models/subject.model';

@Injectable({
  providedIn: 'root'
})
export class SubjectService extends BaseService {

  listAllForSelect(LessonID?: string, searchText: string = '') {
    var queryParam = '';

    if(LessonID)
      queryParam += 'LessonID=' + LessonID + '&';

    if(searchText)
      queryParam += 'query=' + searchText + '&';

    if(queryParam){
      queryParam = '?' + queryParam.substr(0, queryParam.length - 1)
      return this.httpClient.get<ResultModel<SubjectModel[]>>(this.getApiUrl('subjects' + queryParam));
    }
    else{
      return this.httpClient.get<ResultModel<SubjectModel[]>>(this.getApiUrl('subjects'));
    }

  }


  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<SubjectModel[]>>(this.getApiUrl('subjects/list'), formData);
  }

  create(subject: SubjectModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('subjects'), subject);
  }

  update(subject: SubjectModel) {
    return this.httpClient.put(this.getApiUrl('subjects'), subject);
  }

  get(id: string) {
    return this.httpClient.get<{ Subject: SubjectModel }>(this.getApiUrl('subjects/' + id));
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('subjects/' + id));
  }


}
